import { useMutation } from '@tanstack/react-query'
import type { GeneratorType } from '@creanizer/types'
import { apiClient, ApiError } from '../services/api'
import { useGeneratorModel } from '../features/generators/components/GeneratorModelSelector'
import { withGeneratorModel } from '../lib/generatorModelSelection'

export function useGenerator(type: GeneratorType) {
  const modelId = useGeneratorModel(type)

  return useMutation({
    mutationFn: (params: any) =>
      apiClient.generate(type, withGeneratorModel(params, modelId)),
    onError: (error) => {
      console.error(`Generation failed for ${type}:`, error)
      
      // レート制限エラーの場合、ユーザーに通知
      if (error instanceof ApiError && error.isRateLimit) {
        alert('APIキーがレート制限に達しました。しばらく待ってから再試行してください。')
      }
    },
  })
}
